import { UserCircle } from '@phosphor-icons/react';

export default UserCircle;
